import mask from './functions/directive'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('mask', mask)
})
